import { Map, List } from 'immutable'
import { getInOr, get, safeToJS, keys, map } from 'utils/immutable'
import { createSelector } from 'reselect'
import { createDeepEqualSelector } from 'selectors/utils'

const featureIdSelector = createDeepEqualSelector(
  getInOr(Map(), ['feature', 'currentFeature', 'feature']),
  (feature) => feature.valueSeq().first().get('id')
)

const functionsSelector = getInOr(Map(), [
  'feature',
  'currentFeature',
  'functions',
])
const featureFunctionUrisSelector = createDeepEqualSelector(
  functionsSelector,
  keys
)

const allOutputsSelector = getInOr(Map(), [
  'feature',
  'currentFeature',
  'outputs',
])
const allOutputsIdsSelector = createDeepEqualSelector(
  allOutputsSelector,
  (allOutputs) => map(get('id'), allOutputs).valueSeq()
)

const queriesSelector = getInOr(Map(), ['feature', 'currentFeature', 'queries'])
const queriesKeysSelector = createDeepEqualSelector(queriesSelector, keys)

const conditionsSelector = getInOr(Map(), [
  'feature',
  'currentFeature',
  'conditions',
])
const conditionsKeysSelector = createDeepEqualSelector(conditionsSelector, keys)

const componentMetaSelector = getInOr(Map(), ['navigator', 'componentMeta'])
const componentMetaKeysSelector = createDeepEqualSelector(
  componentMetaSelector,
  keys
)

const deleteFunctionOrLogicNodeDataSelector = createSelector(
  componentMetaKeysSelector,
  allOutputsIdsSelector,
  conditionsKeysSelector,
  queriesKeysSelector,
  featureFunctionUrisSelector,
  featureIdSelector,
  (metaKeys, outputIds, conditionKeys, queryKeys, functionUris, featureId) =>
    List([
      metaKeys,
      outputIds,
      conditionKeys,
      queryKeys,
      functionUris,
      featureId,
    ])
)

export const getDeleteFunctionOrLogicNodeData = createSelector(
  deleteFunctionOrLogicNodeDataSelector,
  safeToJS
)
